import MUTATIONTYPES from './mutation-types';
import config from '../core/config';
import role from '../core/config/menu/role';
// import differenceWith from 'lodash/differenceWith';
import intersection from 'lodash/intersection';
import orderBy from 'lodash/orderBy';
// import uniq from 'lodash/uniq';
import { typeOf } from '../core/utils/helper';

const roleKeys = Object.keys(role);

/**
 * 获取最高权限的路由表
 * @param roles
 * @returns {*}
 */
function dealTopRole (roles) {
  const list = [];
  if (!roles) {
    return false;
  }
  roles.forEach(({ role }) => {
    list.push(role.RoleId);
  });

  const newList = intersection(roleKeys, list);
  let topList = [];

  if (newList.length > 1) {
    topList = newList.sort((a, b) => {
      return role[b].weight - role[a].weight;
    });
  }
  else {
    topList = [].concat(newList);
  }

  if (topList.length === 0) {
    return false;
  }

  // 返回唯一的roleMap对象
  return {
    map: role[topList[0]],
    roleId: topList[0],
  };
}

export default {
  // 初始化渲染（解决一些接口未就绪问题）
  [MUTATIONTYPES.INIT_RENDER] (state, payload) {
    state.initRender = payload;
  },

  // 初始化用户中心（右上角）
  [MUTATIONTYPES.INIT_USER_CENTER] (state, payload) {
    state.user.isLogin = true;

    let devsInfo;
    let userInfo = {
      ...payload.account,
      ...payload.profile,
    };

    // 如果是机构用户
    if (payload.agency || payload.ageny) {
      devsInfo = payload.agency || payload.ageny;
      userInfo = Object.assign(userInfo, {
        type: 1,
      });
    }
    else {
      // 供应商用户
      devsInfo = payload.vendor;
    }

    state.user.devs_info = Object.assign({}, devsInfo);
    state.user.user_info = Object.assign({}, userInfo);
  },

  [MUTATIONTYPES.INIT_USER_MENU] (state, payload) {
    const role = dealTopRole(payload.sysroles);
    // 如果不在roleMap里，则认为该用户不符合预期
    if (!role) {
      return false;
    }
    state.user.roleId = role.roleId;
    state.entryList = [].concat(role.map[config.hostType]);
  },

  [MUTATIONTYPES.GET_APP] (state, payload) {
    state.app.current = Object.assign(payload);
  },

  [MUTATIONTYPES.SET_CURRENT_APP] (state, payload) {
    state.app.current = Object.assign({}, payload);
  },

  [MUTATIONTYPES.CHANGE_CURRENT_ENTRY] (state, payload) {
    state.currentEntry = payload.currentEntry;
  },

  // [MUTATIONTYPES.GET_APP_TYPE_LIST] (state, payload) {
  //   if (Array.isArray(payload)) {
  //     state.appTypeList = [].concat(payload);
  //   }
  // },

  [MUTATIONTYPES.INIT_MANAGE_SIDEBAR] (state, payload) {
    state.manageSidebar = [].concat(payload);
  },

  /**
   * 变更控制台的侧栏（主要针对是否有应用模块管理这个目录）
   * @param state
   * @param payload
   */
  [MUTATIONTYPES.CHANGE_MANAGE_SIDEBAR] (state, payload) {
    const appTypeListFromProject = state.appTypeListFromProject;
    const list = [];

    // const prefix = `/${state.manageAppPathName}`;

    appTypeListFromProject.forEach(type => {
      if (type.is_visible) {
        list.push({
          name: type.type_name,
          path: `/app/${type.app_type}`,
        });
      }
    });

    state.manageSidebar.forEach(menu => {
      if (menu.key === 'developManage') {
        menu.children = [].concat(list);
        state.manageSidebar = [].concat(state.manageSidebar);
        if (menu.children.length === 0) {
          menu.action = function () {
            this.$toast.info('暂无应用，请在【应用管理】新增应用');
          };
        }
      }
    });
  },

  // Rio
  [MUTATIONTYPES.GET_SYSTEM_LIST] (state, payload) {
    if (payload.length === 0) {
      return;
    }
    state.system.list = [].concat(orderBy(payload, ['createTime'], ['desc']));
    const currentSystemId = window.localStorage.getItem(config.lsSidName);
    const currentSystem = state.system.list.find(
      item => item.sysid === currentSystemId) || payload[0];
    // 如果本地缓存的sysid与当前系统的不一致，则取当前系统的sysid
    if (currentSystemId !== currentSystem.sysid) {
      window.localStorage.setItem(config.lsSidName, currentSystem.sysid);
    }
    state.system.current = Object.assign({}, currentSystem);
  },

  [MUTATIONTYPES.CHANGE_SYSTEM] (state, payload) {
    window.localStorage.setItem(config.lsSidName, payload.sysid);
    state.system.current = Object.assign({}, payload);
  },

  [MUTATIONTYPES.CHANGE_ENTRY_LIST] (state, payload) {
    if (payload.length === 0) {
      return;
    }
    state.entryListStatus = 0;
    state.entryList.forEach((item, index) => {
      if (typeOf(item) === 'array') {
        const overview = item[0] === 'manage' ? '/overview' : '';
        switch (item[0]) {
          case 'admin/manage/system':
          case 'manage':
            const list = [state.entryList[index][0]];
            payload.forEach(({ name, sysid }) => {
              list.push({
                name,
                url: `${state.entry[item[0]].url}${overview}?sysid=${sysid}`,
              });
            });
            state.entryList[index] = [].concat(list);
            break;
          default:
        }
      }
    });
    state.entryListStatus = 1;
  },
};
